<template>
  <div id="app">
    <main class="retirement-page">
      <div class="retirement-page__glow" aria-hidden="true"></div>

      <section class="retirement-page__content" aria-labelledby="acquisition-title">
        <img
          class="retirement-page__logo"
          src="./assets/imgs/logo.png"
          alt="Derivitec"
        >

        <p class="retirement-page__eyebrow">A new chapter</p>

        <h1 id="acquisition-title">
          Derivitec has been acquired by ActiveViam
        </h1>

        <p class="retirement-page__message">
          Derivitec&rsquo;s derivatives and FX risk expertise is now part of
          ActiveViam. Discover how Atoti Risk Services helps financial
          institutions transform risk data into faster, more informed
          decisions.
        </p>

        <a
          class="retirement-page__link"
          href="https://www.activeviam.com/platform/atoti-risk-services"
        >
          Explore Atoti Risk Services
          <span aria-hidden="true">&rarr;</span>
        </a>
      </section>
    </main>
  </div>
</template>

<style lang="scss">
@import './styles/utilities';
@import './styles/reset';

html,
body,
#app {
  min-height: 100%;
}

body {
  background: $black;
}

.retirement-page {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 100vh;
  min-height: 100svh;
  overflow: hidden;
  padding: 48px $horizontalMargin;
  background:
    linear-gradient(135deg, rgba($blue--dark, 0.65), rgba($black, 0) 58%),
    $black;

  @include medium {
    padding-right: $horizontalMargin--medium;
    padding-left: $horizontalMargin--medium;
  }
}

.retirement-page__glow {
  position: absolute;
  top: -20vw;
  right: -25vw;
  width: 70vw;
  height: 70vw;
  min-width: 520px;
  min-height: 520px;
  border: 1px solid rgba($blue, 0.25);
  border-radius: 50%;
  box-shadow:
    0 0 0 9vw rgba($blue, 0.035),
    0 0 0 18vw rgba($blue, 0.025);
}

.retirement-page__content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 780px;
  margin: 0 auto;
}

.retirement-page__logo {
  display: block;
  width: 176px;
  max-width: 55vw;
  margin-bottom: 72px;
}

.retirement-page__eyebrow {
  margin-bottom: 22px;
  color: lighten($blue, 25%);
  font-size: $fontsize--smaller;
  font-weight: 400;
  letter-spacing: 0.18em;
  line-height: 1.4;
  text-transform: uppercase;
}

.retirement-page h1 {
  max-width: 720px;
  margin-bottom: 30px;
  color: $white;
  font-family: $fontPlayfair;
  font-size: clamp(42px, 7vw, 76px);
  font-weight: 300;
  letter-spacing: -0.025em;
  line-height: 1.08;
  text-transform: none;
}

.retirement-page__message {
  max-width: 650px;
  margin-bottom: 42px;
  color: rgba($white, 0.72);
  font-size: clamp(17px, 2.1vw, 21px);
  font-weight: 300;
  letter-spacing: 0.025em;
  line-height: 1.65;
}

.retirement-page__link {
  display: inline-flex;
  gap: 18px;
  align-items: center;
  padding: 16px 22px;
  border: 1px solid rgba($white, 0.7);
  color: $white;
  font-size: $fontsize--smaller;
  font-weight: 400;
  letter-spacing: 0.14em;
  line-height: 1.4;
  text-decoration: none;
  text-transform: uppercase;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;

  &:hover,
  &:focus {
    background: $white;
    color: $black;
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: 3px solid lighten($blue, 25%);
    outline-offset: 4px;
  }

  span {
    font-size: 1.5em;
    line-height: 0;
  }
}

@media (max-height: 680px) {
  .retirement-page__logo {
    margin-bottom: 40px;
  }
}

@media (max-width: $bp_small - 1) {
  .retirement-page {
    align-items: flex-start;
    padding-top: 42px;
    padding-bottom: 42px;
  }

  .retirement-page__content {
    margin: auto 0;
  }

  .retirement-page__logo {
    margin-bottom: 54px;
  }

  .retirement-page__link {
    width: 100%;
    justify-content: space-between;
  }
}

@media (prefers-reduced-motion: reduce) {
  .retirement-page__link {
    transition: none;
  }
}
</style>
